"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineChartComponent = exports.ChartType = void 0;
/* eslint-disable jsx-a11y/label-has-associated-control */
var d3 = require("d3");
var React = require("react");
var react_1 = require("react");
var Localize_1 = require("../../gen-src/Localize");
var styles = require("../styles/PredictionModelResultsViz");
var colors = require("../util/colors");
var sizes = require("../util/sizes");
var utils_1 = require("../util/utils");
var ChartType;
(function (ChartType) {
    ChartType[ChartType["Gains"] = 0] = "Gains";
    ChartType[ChartType["CumulativeCapture"] = 1] = "CumulativeCapture";
})(ChartType = exports.ChartType || (exports.ChartType = {}));
var LineChartComponent = function (props) {
    var data = props.data, type = props.type;
    var chartRef = react_1.useRef(null);
    var height = sizes.heightTall;
    var width = sizes.widthVeryWide;
    var margin = sizes.chartMargins;
    var chartHeight = height - margin.top - margin.bottom;
    var chartWidth = width - margin.left - margin.right;
    var xAxisTranslate = height - margin.bottom;
    var yAxisTranslate = margin.left;
    // combine data into (x, y) tuples, find max x value
    // y values (cdf) will always be from 0 to 1
    var maxYValue = Number.MIN_SAFE_INTEGER;
    var coordinates = data
        .filter(function (d) {
        var targetData = type === ChartType.Gains ? 'cl' : 'ccr';
        return d.dataType === targetData;
    })
        .map(function (d) {
        maxYValue = Math.max(d.value, maxYValue);
        return [d.cdf, d.value];
    });
    // Create scales
    var xScale = d3
        .scaleLinear()
        .domain([0, 1])
        .range([margin.left, width - margin.right]);
    var yScale = d3
        .scaleLinear()
        .domain([0, Math.round(maxYValue)])
        .range([height - margin.bottom, margin.top]);
    var drawAxes = react_1.useCallback(function (svg) {
        var yAxis = utils_1.getLinearAxis(yScale, utils_1.AxisPosition.Left);
        utils_1.formatAxis(yAxis, 5);
        utils_1.drawAxis(svg, yAxis, yAxisTranslate, 0);
        var xAxis = utils_1.getLinearAxis(xScale, utils_1.AxisPosition.Bottom);
        utils_1.formatAxis(xAxis, sizes.defaultNumTicks, sizes.defaultTickSize, sizes.defaultTickPadding, utils_1.TickFormat.formatK);
        utils_1.drawAxis(svg, xAxis, 0, xAxisTranslate);
    }, [xAxisTranslate, xScale, yAxisTranslate, yScale]);
    var drawBackgroundGrid = react_1.useCallback(function (svg) {
        var backgroundYAxis = utils_1.getLinearAxis(yScale, utils_1.AxisPosition.Left);
        utils_1.formatAxis(backgroundYAxis, 5, -chartWidth, sizes.defaultTickPadding, utils_1.TickFormat.hideNumbers);
        utils_1.drawAxisGridLines(svg, backgroundYAxis, yAxisTranslate, 0);
        var backgroundXAxis = utils_1.getLinearAxis(xScale, utils_1.AxisPosition.Bottom);
        utils_1.formatAxis(backgroundXAxis, sizes.defaultNumTicks, -chartWidth, sizes.defaultTickPadding, utils_1.TickFormat.hideNumbers);
        utils_1.drawAxisGridLines(svg, backgroundXAxis, 0, xAxisTranslate);
    }, [chartWidth, xAxisTranslate, xScale, yAxisTranslate, yScale]);
    var drawLines = react_1.useCallback(function (svg) {
        var line = d3
            .line()
            .x(function (d) {
            return xScale(d[0]) || 0;
        })
            .y(function (d) {
            return yScale(d[1]) || 0;
        })
            .curve(d3.curveMonotoneX);
        svg
            .append('path')
            .datum(coordinates)
            .attr('transform', "translate(0, 0)")
            .attr('d', line)
            .style('fill', 'none')
            .style('stroke', colors.defaultBlue)
            .style('stroke-width', '2');
    }, [coordinates, xScale, yScale]);
    react_1.useEffect(function () {
        d3.select(chartRef.current).selectAll('*').remove(); // To avoid stacking svg every re-render
        var svg = d3.select(chartRef.current).attr('height', height).attr('width', width);
        // draw axes
        var xAxisLabel = Localize_1.Messages.CumulativeDataFraction();
        var yAxisLabel = type === ChartType.Gains ? Localize_1.Messages.Gain() : Localize_1.Messages.CumulativeCaptureRate();
        utils_1.drawAxisLabel(svg, xAxisLabel || '', chartWidth / 2 + margin.left, height);
        utils_1.drawAxisLabel(svg, yAxisLabel || '', sizes.chartFontSize, chartHeight / 2 + margin.top, true);
        drawAxes(svg);
        drawBackgroundGrid(svg);
        // graph points
        drawLines(svg);
        utils_1.drawPoints(svg, coordinates, xScale, yScale, colors.defaultBlue, 3);
        if (type === ChartType.CumulativeCapture) {
            utils_1.draw45DegreeLine(svg, xScale, yScale, coordinates, 0.29);
        }
    }, [
        chartHeight,
        chartWidth,
        coordinates,
        drawAxes,
        drawBackgroundGrid,
        drawLines,
        height,
        margin,
        type,
        width,
        xAxisTranslate,
        xScale,
        yAxisTranslate,
        yScale,
    ]);
    var renderLegend = function () {
        return (React.createElement("div", { className: styles.legend },
            React.createElement("div", { className: styles.legendNoModel }),
            React.createElement("label", { className: styles.legendLabel }, Localize_1.Messages.NoModel()),
            React.createElement("div", { className: styles.legendValidation }),
            React.createElement("label", { className: styles.legendLabel }, Localize_1.Messages.ValidationSet())));
    };
    return (React.createElement("div", { className: styles.lineChartContainer },
        React.createElement("label", { className: styles.lineChartTitle }, type === ChartType.Gains ? Localize_1.Messages.GainsChart() : Localize_1.Messages.CumulativeCaptureRate()),
        type === ChartType.CumulativeCapture ? renderLegend() : null,
        React.createElement("svg", { ref: chartRef })));
};
exports.LineChartComponent = LineChartComponent;
//# sourceMappingURL=LineChartComponent.js.map